export const BENEFICIARY_STRING_CONSTANTS = {
  HEADING: "Beneficiary Details",
  NO_BENEFICIARY_FOUND: "No Beneficiary Found!",
  BENEFICIARY_TABLE_COLUMNS: [
    "#",
    "Account Number",
    "IFSC Code",
    "Account Holder Name",
    "Account State",
    "Bank Name",
    "Beneficiary ID",
    "Edit"
  ]
}